.row {
  position: relative;
  display: block;
}
.row .exiting {
  animation: fadeOut 0.2s ease-in forwards;
  pointer-events: none;
  opacity: 0;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL2NvbW1vbi9jb21wb25lbnRzL2ludGVybmFsL1RpbWVsaW5lL3BhcnRpYWxzIiwic291cmNlcyI6WyJUaW1lbGluZVJvdy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7OztBQUlKO0VBQ0U7SUFDRTs7RUFFRjtJQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLnJvdyB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZGlzcGxheTogYmxvY2s7XG4gIFxuICAuZXhpdGluZyB7XG4gICAgYW5pbWF0aW9uOiBmYWRlT3V0IDAuMnMgZWFzZS1pbiBmb3J3YXJkcztcbiAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgICBvcGFjaXR5OiAwO1xuICB9XG59XG5cbkBrZXlmcmFtZXMgZmFkZU91dCB7XG4gIGZyb20ge1xuICAgIG9wYWNpdHk6IDE7XG4gIH1cbiAgdG8ge1xuICAgIG9wYWNpdHk6IDA7XG4gIH1cbn0iXX0= */